module.exports = __webpack_public_path__ + "img/6.0ed00f70.jpg";